module.exports = __webpack_public_path__ + "img/swisscom.9f0f2b1f.jpg";